<template>
  <div class="payment-apis">
    <div class="form-group field" :class="acctitle ? 'has-content' : ''" v-show="!failedPayment">
      <input
        name="direct-debit-holder-name"
        type="text"
        v-model="acctitle"
        id="direct-debit-holder-name"
        title="Required"
        class="form-control input-lg acctitle"
        placeholder="Bank Account Holder Name"
        autocomplete="off"
        v-validate="{required: true, regex: /^[a-zA-Z ]+$/}"
        :class="{'border-red': errors.has('direct-debit-holder-name')}"
      />
      <!-- /^[a-zA-Z]+$/ -->
      <label
        for="direct-debit-holder-name"
      >Bank Account Holder Name {{ errors.first('direct-debit-holder-name') ? (acctitle && acctitle.length > 0 ? 'invalid' : 'required') : '' }}</label>
      <!-- class="invalid help-block field-validation-error acctitle-err" -->
    </div>

    <div class="form-group field" :class="accrouting ? 'has-content' : ''" v-show="!failedPayment">
      <input
        name="direct-debit-BSB"
        id="direct-debit-bsb"
        v-model="accrouting"
        title="Required"
        class="form-control input-lg accrouting"
        type="text"
        placeholder="Bank Account BSB"
        v-validate="{required: true, regex: /^[0-9]{3}(-?)[0-9]{3}\b$/}"
        :class="{'border-red': errors.has('direct-debit-BSB')}"
      />
      <!-- /^[0-9]{3}(-?)[0-9]{3}\b$/ -->
      <!-- Matches with 3 and 3 seperated by hyphen or nothing -->
      <label
        for="direct-debit-BSB"
      >Bank Account BSB {{ errors.first('direct-debit-BSB') ? (accrouting && accrouting.length > 0 ? 'invalid' : 'required') : '' }}</label>
      <!-- class="invalid help-block field-validation-error accrouting-err" -->
    </div>

    <div class="form-group field" :class="accno ? 'has-content' : ''" v-show="!failedPayment">
      <input
        name="direct-debit-account-number"
        v-model="accno"
        id="direct-debit-account-number"
        title="Required"
        class="form-control input-lg accno"
        type="text"
        placeholder="Bank Account Number"
        v-validate="{required: true, regex: /^[0-9]{6,10}$/}"
        :class="{'border-red': errors.has('direct-debit-account-number')}"
      />
      <label
        for="direct-debit-account-number"
      >Bank Account Number {{ errors.first('direct-debit-account-number') ? (accno && accno.length > 0 ? 'invalid' : 'required') : '' }}</label>
      <!-- <label class="invalid help-block field-validation-error accno-err"></label> -->
    </div>

    <div class="errors" v-if="serverError">
      <label>{{ serverError }}</label>
    </div>

    <div class="form-buttons" v-if="!failedPayment">
      <button
        type="button"
        :class="{ 'disabled': !enablePayButton() }"
        :disabled="!enablePayButton()"
        class="pay-now"
        href="#form-top"
        data-animation-duration="300"
        data-animation-easing="swing"
        id="pay-button"
        @click="Pay"
        data-smooth-scroll
        data-threshold="75"
      >Pay Now</button>
    </div>

    <div class="form-buttons" v-if="failedPayment">
      <button
        type="button"
        class="pay-now"
        href="#form-top"
        data-animation-duration="300"
        data-animation-easing="swing"
        id="retry-button"
        @click="retry"
        data-smooth-scroll
        data-threshold="75"
      >Retry</button>
    </div>
  </div>
</template>

<style>
.payment-apis .pay-now {
  text-transform: initial;
  font-size: 15px;
  line-height: 24px;
  height: auto;
  background-color: var(--primaryColor) !important;
}

.payment-apis .pay-now.disabled {
  cursor: default;
  background-color: var(--wwfGreyDE) !important;
}

.errors label {
  font-size: 15px;
  color: var(--errorColor);
  display: block;
  margin-bottom: 10px;
}
</style>

<script>
import { mapState } from "vuex";

export default {
  name: "VueBamboraDirectDebit",
  data() {
    return {
      accno: "",
      accrouting: "",
      acctitle: "",
      serverError: "",
      failedPayment: false,
    };
  },
  mounted() {},
  computed: mapState({
    donation: (state) => state.donation.donation,
  }),
  methods: {
    enablePayButton: function () {
      return this.acctitle &&
        this.accno &&
        this.accrouting &&
        (!this.errors || !this.errors.items || this.errors.items.length === 0)
        ? true
        : false;
    },
    Pay: function () {
      return new Promise((resolve, reject) => {
        this.serverError = "";
        this.$validator.validateAll().then((result) => {
          if (!result) {
            reject("Direct Debit checkout is invalid.");
          } else {
            this.$emit("success", {
              accno: this.accno,
              accrouting: this.accrouting,
              acctitle: this.acctitle,
            });
          }
        });
      });
    },
    retry() {
      this.$emit("retry");
      this.resetForm();
    },
    resetForm() {
      (this.accno = ""), (this.accrouting = "");
      this.acctitle = "";
      this.serverError = undefined;
    },
    reset(error) {
      this.resetForm();
      if (error) {
        this.serverError = error;
        this.failedPayment = true;
      } else {
        this.failedPayment = false;
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// VueBamboraDirectDebit.vue?1fe323ed